import BenchlingConfig from 'BenchlingConfig';

export function isSimpleRulesEnabled(): boolean {
  return BenchlingConfig.VALIDATION_RULES_ENGINE_ENABLE_M3 || BenchlingConfig.PARTS_ENABLE_OVERLAPPING_PARTS;
}
